export enum ErrorCode {
  Unauthorized = 401,
  Forbidden = 403,
  PageNotFound = 404,
  ValidationFailed = 422,
  ServerError = 500,
}

export enum OAuthErrorCode {
  InvalidToken = 100,
  InappropriateAccount = 101,
}
